import { render, staticRenderFns } from "./videoCom.vue?vue&type=template&id=791a8950&scoped=true&"
import script from "./videoCom.vue?vue&type=script&lang=js&"
export * from "./videoCom.vue?vue&type=script&lang=js&"
import style0 from "./videoCom.vue?vue&type=style&index=0&id=791a8950&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791a8950",
  null
  
)

export default component.exports